<template>
  <div class="superContract-partnerManage-page">
    <p class="hasBottomLine"><span class="link-wrap" @click="toGoManage()">币种管理 > </span> 项目方管理</p>
    <div class="header-seach-box">
      <!-- <div class="inputWithSelectBox">
        <el-input
          placeholder="输入前，请选择抵押币种或者借贷币种"
          :disabled="serchInfo.selectType == 0 ? true : false"
          v-model="serchInfo.selectCoin"
          class="input-with-select"
        >
          <el-select v-model="serchInfo.selectType" slot="prepend" @change="hanldSelectType()" placeholder="请选择">
            <el-option label="抵押币种" value="1"></el-option>
            <el-option label="借贷币种" value="2"></el-option>
            <el-option label="全部" value="0"></el-option>
          </el-select>
          <el-button slot="append" @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
        </el-input>
      </div> -->
      <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">关联项目方</el-button>
    </div>

    <div class="table-box">
      <el-table :data="partnerProjectListInfo" border style="width: 99.9%">
        <el-table-column prop="userId" label="项目方账户ID" width="80"> </el-table-column>
        <el-table-column prop="projectName" label="项目方名称"> </el-table-column>
        <el-table-column prop="coinAmount" :label="'可用备付金（' + $route.query.coinType + ')'"> </el-table-column>
        <el-table-column prop="coinFroze" :label="'冻结备付金（' + $route.query.coinType + ')'"> </el-table-column>
        <el-table-column prop="maxCoinPosition" :label="'项目方最大持仓量（' + $route.query.coinType + ')'"> </el-table-column>

        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == true">上架</span>
            <span v-else style="color:red">下架</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="updateTime" label="最新编辑时间">
          <template slot-scope="scope">
            <span> {{ scope.row.updateTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="maxDay" label="操作" width="340">
          <template slot-scope="scope">
            <!-- <el-button type="primary" v-if="!scope.row.status" @click="preceptStatus(scope.row, true, scope.$index)"
              >上架</el-button
            >
            <el-button type="danger" v-else @click="preceptStatus(scope.row, false, scope.$index)">下架</el-button> -->

            <el-button type="success" @click="bianji(scope.row, scope.$index)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="generalListTotal"
      >
      </el-pagination>
    </div>

    <!---dialog--->
    <el-dialog title="项目方上下架开关" class="bk-ui5-dialog" :visible.sync="upOrDownDialog">
      <p class="descText" v-if="editInfo.status == true">
        是否下架该合作方：<span style="color:red">{{ editInfo.userId }} </span>
      </p>
      <p v-else>确认上架？</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upOrDownDialog = false">取 消</el-button>
        <el-button type="primary" @click="upOrDownSwitchBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitleText" class="bk-ui5-dialog" :visible.sync="editDialog">
      <el-form ref="form" :model="updateInfo" label-width="150px">
        <el-form-item label="项目方id" v-if="diaStatus == 'add'">
          <el-input v-model="updateInfo.userId"></el-input>
        </el-form-item>
        <el-form-item label="项目方名称">
          <el-input v-model="updateInfo.projectName"></el-input>
        </el-form-item>
        <el-form-item label="保证金币种" v-if="diaStatus == 'add'">
          <el-input v-model="updateInfo.marginCoin"></el-input>
        </el-form-item>
        <el-form-item label="保证金数量" v-if="diaStatus == 'add'">
          <el-input v-model="updateInfo.marginAmount"></el-input>
        </el-form-item>

        <el-form-item label="项目方最大持仓量">
          <el-input v-model="updateInfo.maxCoinPosition"></el-input>
        </el-form-item>

        <el-form-item label="上架状态">
          <el-switch v-model="updateInfo.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" v-if="diaStatus == 'add'" @click="addCommitBtn()">新 增</el-button>
        <el-button type="success" v-else @click="editCommitBtn()">修 改</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择添加支持指数标的" class="bk-ui5-dialog" width="600px" :visible.sync="supportDialog">
      <el-select v-model="addCoinValue" placeholder="请选择">
        <el-option v-for="(item, index) in supportCoinArr" :key="index" :label="item" :value="item" :disabled="item == '上海'">
        </el-option>
      </el-select>

      <div slot="footer" class="dialog-footer">
        <el-button @click="supportDialog = false">取 消</el-button>
        <el-button type="primary" @click="supportCommitBtn()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "partnerManage",
  data() {
    return {
      supportCoinArr: [],
      addCoinValue: "",
      editDialog: false,
      dialogTitleText: "",
      diaStatus: "edit",
      upOrDownDialog: false,
      value: "",
      editInfo: {},
      selectType: "0",
      serchInfo: {
        selectType: "1", //0全部  1 抵押币种 2借贷币种
        selectCoin: "",
        statusType: "0" //0 全部  1停用 2启用
      },
      supportDialog: false,
      currentPage: 1,
      pageSize: 10,

      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      updateInfo: {
        status: false
      },
      marginFold: []
    };
  },
  computed: {
    ...mapState("FinanceManage", ["partnerProjectListInfo", "generalListTotal"])
  },
  methods: {
    ...mapActions("FinanceManage", ["partnerList"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {},
    pageChange(val) {
      this.getPageListInfo();
    },

    getPageListInfo() {
      let postData = {
        configId: this.$route.query.configId
      };

      this.partnerList(postData);
    },

    handleSearch() {},
    showDialog(n) {
      this.dialogArr[n] = true;
    },
    handleOpenSwitch(openStatus) {
      this.dialogArr.openSwitchDialog = true;
      return false;
    },
    clearForm() {
      this.editDialog = false;
      this.upOrDownDialog = false;
      this.supportDialog = false;
    },

    preceptStatus(row, status, index) {
      this.upOrDownDialog = true;
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.editInfo.indexNum = index;
    },

    //上架或下架 按钮
    upOrDownSwitchBtn() {
      let that = this;
      api
        .udpateProjectStatus({
          id: that.editInfo.id,
          status: !that.editInfo.status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    operationBtn() {
      let that = this;
      api.mortgageOperation(that.operationForm).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getMortgageConfig();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    editBtn(row, status) {
      this.dialogTitleText = "关联项目方";

      this.diaStatus = "add";
      this.updateInfo = {
        userId: "",
        projectName: "",
        marginCoin: "",
        marginAmount: "",
        maxCoinPosition: "",
        configId : this.$route.query.configId,
        status:false
      };
      this.editDialog = true;
    },

    bianji(row) {
      this.updateInfo = JSON.parse(JSON.stringify(row));
      this.dialogTitleText = "关联项目方";
      this.diaStatus = "edit";
      this.editDialog = true;
    },
    addSupportCoin(row) {
      this.supportDialog = true;
      this.updateInfo = JSON.parse(JSON.stringify(row));
    },

    getIndexCoinsE() {
      let that = this;
      api.getIndexCoins().then(res => {
        if (!res.code) {
          that.supportCoinArr = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    supportCommitBtn() {
      let that = this;
      api
        .addConfigIndexCoin({
          configId: that.updateInfo.id,
          indexCoin: that.addCoinValue
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },
    putawayIndexCoin(id, status) {
      let that = this;
      api
        .updateConfigIndexCoin({
          id: id,
          status: !status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    getGeneralConfigE(id) {
      let that = this;

      api
        .getGeneralConfig({
          id: id
        })
        .then(res => {
          if (!res.code) {
            that.updateInfo = JSON.parse(JSON.stringify(res.data));
            that.marginFold = that.updateInfo.leverage;
            that.dialogTitleText = that.updateInfo.coinType + "-" + that.updateInfo.userId + "参数设置";
            that.diaStatus = "edit";
            that.editDialog = true;
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    editCommitBtn() {
      let that = this;
      let postData = JSON.parse(JSON.stringify(this.updateInfo));
      postData.projectUserId = postData.userId;
      api.updateProejct(postData).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getPageListInfo();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    addCommitBtn() {
      let that = this;
      if (
        that.updateInfo.userId &&
        that.updateInfo.projectName &&
        that.updateInfo.marginCoin &&
        that.updateInfo.marginAmount &&
        that.updateInfo.maxCoinPosition
      ) {
       
        let postData = JSON.parse(JSON.stringify(this.updateInfo));
        api.generalAddProejct(postData).then(res => {
          if (!res.code) {
            that.clearForm();
            that.getPageListInfo();
            that.$message.success(res.msg);
          } else {
            that.$message.error(res.msg);
          }
        });
      } else {
        that.$message.error("请填写完整");
      }
    },

    toGoManage() {
      this.$router.push("/home/finance/manage/mortgage/partnerManage");
    }
  },
  created() {},
  mounted() {
    this.updateInfo.configId = this.$route.query.configId;
    this.getIndexCoinsE();
    this.getPageListInfo();
  }
};
</script>

<style lang="less">
.superContract-partnerManage-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-size: 18px;
    border-bottom: 1px solid #cccccc;

    .link-wrap {
      color: #6385ed;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
        .indexCoinClome {
          .greyCol {
            color: #cccccc;
          }

          .el-button--text {
            padding-left: 30px;
            label {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .titleStrong {
          font-size: 18px;
          font-weight: bold;
        }

        .el-form {
          .setSmallInput {
            .el-form-item__label {
              width: 170px !important;
            }
            .el-form-item__content {
              margin-left: 170px !important;
              display: flex;
              justify-content: space-between;
              .el-input {
                padding-right: 12px;
                text-align: center;
                .el-input-group__append {
                  padding: 0 6px;
                }
              }
              .divText {
                width: 200px;
                text-align: center;
                padding: 0 20px;
              }
            }
          }
        }

        .fenFiveInput {
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
